<template>
  <!--begin::Card-->
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body">
    <nav class="navbar navbar-light" style="background-color: #e3f2fd;">
        <div class="container-fluid">
          <a class="navbar-brand"> {{nameNavbar}}</a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <!-- <li class="nav-item">
                <a class="nav-link active" aria-current="page" >Añadir Docentes</a>
              </li> -->
              <!-- profesores -->
              <li class="nav-item dropdown">
                <a 
                  class="nav-link dropdown-toggle" 
                  id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Profesores
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><a class="dropdown-item cursor_pointer" @click="addTeacher">Añadir profesor</a></li>
                  <li><a class="dropdown-item cursor_pointer" @click="listTeachers">Lista profesores</a></li>
                  <!-- <li><hr class="dropdown-divider"></li>
                  <li><a class="dropdown-item" href="#">Something else here</a></li> -->
                </ul>
              </li>
              <!-- Estudiantes -->
              <li class="nav-item dropdown cursor_pointer">
                <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Estudiantes
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><a class="dropdown-item" @click="addStudent">Añadir Estudiante</a></li>
                  <li><a class="dropdown-item" @click="listStudents">Lista Estudiantes</a></li>
                  <li><a class="dropdown-item" @click="listBachelors">Lista Programa de Bachillerato</a></li>
                  <!-- <li><hr class="dropdown-divider"></li>
                  <li><a class="dropdown-item" href="#">Something else here</a></li> -->
                </ul>
              </li>
              <li><hr class="dropdown-divider"></li>
              <!-- Parametros -->
                <li class="nav-item dropdown cursor_pointer">
                <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Parámetros
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><a class="dropdown-item" @click="addCourse">Carreras, Asignaturas, Talleres, Cursos o Capacitaciones</a></li>
                  <li><a class="dropdown-item" @click="addInstitution">Instituciones</a></li>
                  <!-- <li><hr class="dropdown-divider"></li>
                  <li><a class="dropdown-item" href="#">Something else here</a></li> -->
                </ul>
              </li>
              <!-- <li class="nav-item">
                <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Disabled</a>
              </li> -->
            </ul>
          </div>
        </div>
      </nav>
      <!-- agregar profesores -->
      <div v-if="isAddingTeacher" class="row p-3">
       <h4>{{!isAddingCoursesTeacher?'Registro de Profesores':'Adición de asignatura o especialidad'}}</h4>
        <div class="row">
          <div class="col-md-6 p-2">
            <label for="" required>Nombre completo:</label>
            <input 
              type="text"
              class="form-control"
              v-uppercase
              :disabled="isAddingCoursesTeacher"
              v-model.trim="stateTeacher[0].nombre_completo"
            >
          </div>
          <div class="col-md-6 p-2">
            <label for="" required>Número de Documento de identidad:</label>
            <input 
              type="text" 
              class="form-control"
              :disabled="isAddingCoursesTeacher"
              v-model.trim="stateTeacher[0].numero_documento"
            >
          </div>
        </div>
        <hr style="margin-top:20px;">
        <div class="row">
        <div class="col-md-6 p-2">
          <label for="" required>Área de Formación:</label>
          <select 
            class="form-select"
            v-model.trim="teacherClass.id_area_formacion"
            id="area_formacion_teacher"
          >
          <option selected disabled>Seleccione una opción</option>
          <option 
            v-for="area in areaFormacionList" 
            :key="area.id_area_formacion" 
            :value="area.id_area_formacion"
          >
            {{ area.nombre_area_formacion }} - {{area.cod_area_formacion}}
          </option>
          </select>
        </div>
        <!-- ASIGNATURA ESPECIALIDAD -->
        <div class="col-md-6 p-2">
          <label for="nombre-materia">Asignatura o Especialidad:</label>
          <select 
            class="form-select"
            v-model.trim="teacherClass.id_asignatura"
          >
            <option selected disabled>Seleccione una opción</option>
            <option 
              v-for="asignatura in asignaturaListByAreaFormacion" 
              :key="asignatura.id_asignatura" 
              :value="asignatura.id_asignatura"
            >
              {{ asignatura.nombre_asignatura }} - {{ asignatura.nombre_institucion }}
            </option>
          </select>
         </div>
        </div>
        <div class="row">
          <div class="col-md-6 p-2">
          <label for="" required>Horario de ingreso:</label>
            <input type="time" class="form-control" v-model.trim="teacherClass.hora_ingreso">
          </div>
          <div class="col-md-5 p-2">
          <label for="" required>Horario de salida:</label>
            <input type="time" class="form-control" v-model.trim="teacherClass.hora_salida">
          </div>
          <div class="col-md-1 py-8">
            <button class="btn btn-primary"  :disabled="!teacherClass.id_area_formacion ||
                                                          !teacherClass.id_asignatura ||
                                                          !teacherClass.hora_ingreso ||
                                                          !teacherClass.hora_salida 
                                                          " @click="addTeacherToArray"> Añadir</button>
          </div>
        </div>
        <div class="row table-responsive">
          <table class="table">
           <thead>
             <tr>
               <th scope="col">Nombre completo</th>
               <th scope="col">Nro. Documento</th>
               <th scope="col">Asignatura o Especialidad</th>
               <th scope="col">Área de Formación</th>
               <th scope="col">Institución</th>
               <th scope="col">Hora de Ingreso y salida</th>
               <th scope="col">Acciones</th>
             </tr>
           </thead>
           <tbody>
             <tr v-if="stateTeacher[0].materias.length==0">
               <td colspan="6">
                 No existen registros de profesores.
               </td>
             </tr>
             <tr v-for="(materia, index) in stateTeacher[0].materias" :key="index">
               <td style="text-align:center" v-if="index === 0" :rowspan="stateTeacher[0].materias.length">{{ stateTeacher[0].nombre_completo }}</td>
               <td v-if="index === 0" :rowspan="stateTeacher[0].materias.length">{{ stateTeacher[0].numero_documento }}</td>
               <td>{{ getNameFromCourse(materia, 'nombre_asignatura') }}</td>
               <td> {{getNameFromCourse(materia,'nombre_area_formacion') }}</td>
               <td> {{getNameFromCourse(materia,'nombre_institucion') }}</td>
               <td>{{ materia.hora_ingreso }} - {{ materia.hora_salida }}</td>
               <td data-label="Acciones">
                <div class="icon-container">
                 <i class="fa fa-edit fa-2x" style="color:skyblue" title="editar" @click="editTeacher(materia, index)"></i>&nbsp;
                </div>
                <div class="icon-container">
                 <i class="fa fa-trash fa-2x" style="color:red" title="eliminar" @click="deleteTeacher(index)"></i>
                </div>
               </td>
             </tr>
           </tbody>
          </table>
        </div>
        <p class="p-2" align="right">
            <button
              class="btn btn-danger"
              @click="clearFormTeacher()"
            >
              Limpiar
            </button>&nbsp;
            <button
              v-if="!isLoading"
              class="btn btn-success"
              @click="registerTeacher()"
            >
              {{!isAddingCoursesTeacher?'Registrar profesor':'Agregar Asignatura o Especialidad'}}
            </button>
            <button
                v-else
                class="btn btn-primary"
                disabled
              >
                Por favor espere ...
              </button>
          </p>
      </div>
      <!-- lista de profesores -->
      <div v-if="isListTeachers" class="row p-3">
      <h4>Lista de Profesores</h4>
        <div class="row table-responsive">
          <table class="table">
           <thead>
             <tr>
               <th scope="col">Acciones Profesor</th>
               <th scope="col">Nombre completo</th>
               <th scope="col">Nro. Documento</th>
               <th scope="col">Asignatura o Especialidad</th>
               <th scope="col">Área de Formación</th>
               <th scope="col">Institución</th>
               <th scope="col">Hora de Ingreso y salida</th>
               <th scope="col">Acciones asignatura</th>
               
             </tr>
           </thead>
           <tbody>
            <template v-for="profesor in teachersList" :key="profesor.id_profesor">
              <tr v-for="(materia, index) in profesor.materias" :key="materia.id_profesor_asignatura">
              <td data-label="Acciones profesor" v-if="index === 0" :rowspan="profesor.materias.length">
                  <div class="icon-container">
                  <i class="fa fa-plus-circle fa-2x" style="color:skyblue" title="agregar una asignatura" @click="addCoursesTeacher(profesor)"></i>&nbsp;
                  </div>
                  <div class="icon-container">
                  <i class="fa fa-trash fa-2x" style="color:red" title="eliminar profesor" @click="deleteTeacherRegistered(profesor)"></i>
                  </div>
                </td>
                <td data-label="nombre" v-if="index === 0" :rowspan="profesor.materias.length">{{ profesor.nombre_completo }}</td>
                <td data-label="N° Documento" v-if="index === 0" :rowspan="profesor.materias.length">{{ profesor.numero_documento }}</td>
                <td data-label="Asignatura">{{ materia.nombre_asignatura }}</td>
                <td data-label="Área formación">{{ materia.nombre_area_formacion }}</td>
                <td data-label="Institución">{{ materia.nombre_institucion }}</td>
                <td data-label="ingreso-Salida">{{ materia.hora_ingreso }} - {{ materia.hora_salida }}</td>
                <td data-label="Acciones asignatura">
                  <div class="icon-container">
                  <i class="fa fa-trash fa-2x" style="color:red" title="eliminar asignatura" @click="deleteTeacherCourseRegistered(materia, profesor)"></i>
                  </div>
                </td>
              </tr>
            </template>
           </tbody>
          </table>
        </div>
      </div>
      <!-- agregar estudiantes -->
      <div v-if="isAddingStudent">
          <!--búsqueda de persona privada de libertad -->
            <div class="row my-5">
              <div class="col-md-4 mt-5">
                <label class="form-label"
                  >Búsqueda PPL:
                  <i
                    class="fas fa-info-circle"
                    title="La búsqueda deberá realizarse por el Nombre completo o Número de documento de identidad"
                  >
                  </i>
                </label>
                <input
                  type="text"
                  class="form-control fuente"
                  style="text-transform: uppercase"
                  id="dato"
                  v-model.trim="dato_busqueda_ppl"
                  @keyup.enter="searchPpl(dato_busqueda_ppl)"
                  @input="checkFieldEmpty($event, dato_busqueda_ppl, 'dato_ppl')"
                />
              </div>
              <div class="col-md-3 col-sm-12 mt-7">
                <button
                  type="button"
                  style="margin: 5px"
                  class="btn px-3"
                  :disabled="!dato_busqueda_ppl"
                  @click="searchPpl(dato_busqueda_ppl)"
                >
                  <i
                    title="Realizar búsqueda de Ppl"
                    style="font-size: 1.5em; color: Dodgerblue"
                    class="fas fa-magnifying-glass"
                  ></i>
                </button>
                <button
                  type="button"
                  style="margin: 10px"
                  class="btn px-3"
                  @click="
                    (dato_busqueda_ppl = ''),
                      (resultados_ppls = []),
                      (stateStudent.formData.id_persona = null)
                  "
                >
                  <i
                    title="Vaciar campo"
                    style="font-size: 1.5em; color: red"
                    class="fas fa-trash"
                  ></i>
                </button>
              </div>
            </div>
            <!-- lista de ppls -->
            <div class="row table-responsive">
              <table class="table">
                <caption v-if="resultados_ppls.length > 0" style="caption-side: top">
                  {{
                    resultados_ppls.length === 1 ? "Existe" : "Existen"
                  }}
                  {{
                    resultados_ppls.length
                  }}
                  {{
                    resultados_ppls.length === 1
                      ? "coincidencia"
                      : " posibles coincidencias"
                  }}
                </caption>
                <thead>
                  <tr >
                    <th>NOMBRE PPL</th>
                    <th>N° DOCUMENTO</th>
                    <th>RECINTO PENITENCIARIO</th>
                    <th>DELITO</th>
                    <th>SELECCIONAR</th>
                  </tr>
                </thead>
                <tbody>
                  <td v-if="resultados_ppls.length == 0 && !isLoading" colspan="8">
                    Sin datos que mostrar
                  </td>
                  <td v-else-if="resultados_ppls.length == 0 && isLoading" colspan="8">
                    Cargando...
                  </td>
                  <tr v-else v-for="dato in resultados_ppls" :key="dato.id_persona">
                    <td data-column="NOMBRE PPL">{{ dato.nombre_completo }}</td>
                    <td data-column="N° DOCUMENTO">{{ dato.nro_doc }}</td>
                    <td data-column="RECINTO">
                      {{ dato.nombre_recinto_penitenciario }}
                    </td>
                    <td data-column="DELITO">{{ dato.descripcion_delito }}</td>
                    <td data-column="SELECCIONAR">
                      <input
                        type="radio"
                        :value="dato.id_persona"
                        :id="dato.id_persona"
                        v-model="stateStudent.formData.id_persona"
                      />
                    </td>
                  </tr>
                </tbody>
                <!-- <span class="text-danger" v-if="!stateStudent.formData.id_persona">
                  Seleccione una Persona Privada de Libertad
                </span> -->
              </table>
            </div>
            <div class="row">
            <!-- AREA FORMACION -->
              <div class="col-md-6 p-2">
                <label for="" required>Área de formación:</label>
                <select 
                  class="form-select"
                  v-model.trim="stateStudent.formData.id_area_formacion"
                  id="area_formacion_institucion"
                >
                  <option selected disabled>Seleccione una opción</option>
                  <option 
                    v-for="area in areaFormacionList" 
                    :key="area.id_area_formacion" 
                    :value="area.id_area_formacion"
                  >
                    {{ area.nombre_area_formacion }} - {{area.cod_area_formacion}}
                  </option>
                </select>
              </div>
              <!-- ASIGNATURA -->
              <div class="col-md-6 p-2">
                <label for="nombre-materia">Asignatura o Especialidad:</label>
                <select 
                  class="form-select"
                  v-model.trim="stateStudent.formData.id_asignatura"
                >
                  <option selected disabled>Seleccione una opción</option>
                  <option 
                    v-for="asignatura in asignaturaListByAreaFormacion" 
                    :key="asignatura.id_asignatura" 
                    :value="asignatura.id_asignatura"
                  >
                    {{ asignatura.nombre_asignatura }} - {{ asignatura.nombre_institucion }}
                  </option>
                </select>
              </div>
              <p class="p-2" align="right">
            <button
              class="btn btn-danger"
              @click="clearFormStudent()"
            >
              Limpiar
            </button>&nbsp;
            <button
              v-if="!isLoading"
              class="btn btn-success"
              :disabled="!validateRegisterStudentForm"
              @click="isEditingStudent?registerEditedStudent():registerStudent()"
            >
              {{isEditingStudent?'Editar':'Registrar'}} Estudiante
            </button>
            <button
                v-else
                class="btn btn-primary"
                disabled
              >
                Por favor espere ...
              </button>
          </p>
            </div>
      </div>
      <!-- lista estudiantes -->
      <div v-if="isListStudents" class="row p-3">
      <h4>Lista de Estudiantes</h4>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">N°</th>
              <th scope="col">Acciones</th>
              <th scope="col">Estudiante</th>
              <th scope="col">Nro. Documento</th>
              <th scope="col">Área de Formación</th>
              <th scope="col">Asignatura</th>
              <th scope="col">Recinto Penitenciario</th>
              <th scope="col">Departamento Recinto Penitenciario</th>
            </tr>
          </thead>
          <tbody>
            <td v-show="studentsList.length==0" colspan="8"> No existen registros para mostrar</td>
            <tr v-for="(student, index) in studentsList" :key="student.id_estudiante_asignatura">
              <td data-label="N°">{{index+1}}</td>
              <td data-label="Acciones">
              <div class="icon-container">
               <i 
                class="fa fa-edit fa-2x" 
                style="color:skyblue" 
                title="editar"
                @click="fillEditStudent(student)"
                ></i>&nbsp;
              </div>
              <div class="icon-container">
               <i 
                class="fa fa-trash fa-2x" 
                style="color:red" 
                title="inhabilitar"
                @click="deleteStudent(student)"></i>
              </div>
              </td>
              <td data-label="Nombre">{{student.nombre_completo}}</td>
              <td data-label="Nro. Doc">{{student.nro_documento}}</td>
              <td data-label="Á. de Formación">{{student.nombre_area_formacion}}</td>
              <td data-label="Asignatura">{{student.nombre_asignatura}}</td>
              <td data-label="Recinto">{{student.nombre_recinto_penitenciario}}</td>
              <td data-label="Departamento">{{student.departamento}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- lista bachilleres -->
      <div v-if="isListBachelors" class="row p-3">
      <h4>Lista de bachilleres</h4>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Nombre completo</th>
              <th scope="col">Nro. Documento</th>
              <th scope="col">Edad</th>
              <th scope="col">Género</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-label="Nombre">JUAN PEREZ ROJAS</td>
              <td data-label="Nro. Doc">8348558</td>
              <td data-label="Edad">34</td>
              <td data-label="Género">MASCULINO</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- agregar asignaturas -->
      <div v-if="isCourse" class="row p-3">
        <h4>{{isEditingCourse?'Editar':'Registrar'}} Carrera Universitaria, Asignatura, Capacitación, Curso o Taller </h4>
       <!-- RECINTO PENITENCIARIO -->
        <div class="col-md-6 p-2">
          <label for="" required>Centro Penitenciario:</label>
          <select 
            class="form-select"
            id="recinto_penitenciario"
            v-model.trim="stateCourse.formData.id_recinto_penitenciario"
          >
          <option selected disabled>Seleccione una opción</option>
            <option 
              v-for="prision in prisionsList" 
              :key="prision.id_recinto_penitenciario" 
              :value="prision.id_recinto_penitenciario"
            >
              {{ prision.nombre_recinto_penitenciario }}
            </option>
          </select>
        </div>
        <!-- AREA FORMACION -->
        <div class="col-md-6 p-2">
          <label for="" required>Área de formación:</label>
          <select 
            class="form-select"
            v-model.trim="stateCourse.formData.id_area_formacion"
            @change="clearInputsAreaFormation(stateCourse.formData.id_area_formacion)"
          >
            <option selected disabled>Seleccione una opción</option>
            <option 
              v-for="area in areasFormacionAgregando" 
              :key="area.id_area_formacion" 
              :value="area.id_area_formacion"
            >
              {{ area.nombre_area_formacion }} - {{area.cod_area_formacion}}
            </option>
          </select>
        </div>
        <div class="col-md-6 p-2">
          <label for="" required>Tipo:</label>
          <select 
            class="form-select"
            v-model.trim="stateCourse.formData.tipo"
          >
            <option selected disabled>Seleccione una opción</option>  
            <option 
              v-for="(tipo, index) in tipoCurso" 
              :key="index" 
              :value="tipo.valor"
            >
              {{ tipo.label }}
            </option>
          </select>
        </div>
        <div
           v-if="stateCourse.formData.id_area_formacion && 
                    (tipoCurso[0].area_formacion==='EDUCACIÓN TÉCNICA ALTERNATIVA' && tipoCurso[0].area_formacion!=='EDUCACIÓN SUPERIOR UNIVERSITARIA')" 
           class="col-md-6 p-2">
          <label for="" required>Nivel:</label>
          <select 
            class="form-select"
            v-model.trim="stateCourse.formData.nivel"
          >
            <option selected disabled>Seleccione una opción</option>  
            <option value="BÁSICO">BÁSICO</option>
            <option value="AUXILIAR">AUXILIAR</option>
            <option value="MEDIO">MEDIO</option>
          </select>
        </div>
        <div class="col-md-6 p-2">
          <label for="" required>Nombre {{capitalize(stateCourse.formData.tipo)}}:</label>
          <input 
            type="text"
            class="form-control"
            v-uppercase
            v-model.trim="stateCourse.formData.nombre"
          >
        </div>
        <div class="col-md-6 p-2">
          <label for="" required>Institución:</label>
          <select 
            class="form-select"
            v-model.trim="stateCourse.formData.institucion"
          >
            <option selected disabled>Seleccione una opción</option>
            <option 
              v-for="(institucion, index) in institutionsListByAreaFormacion" 
              :key="index" 
              :value="institucion.id_institucion"
            >
              {{ institucion.nombre_institucion }}
            </option>
          </select>
        </div>
        <div class="col-md-6 p-2">
          <label for="" required>Fecha:</label>
          <input 
            type="date"
            class="form-control"
            v-uppercase
            :disabled="stateCourse.formData.id_area_formacion && 
                       (tipoCurso[0].area_formacion==='EDUCACIÓN TÉCNICA ALTERNATIVA' || tipoCurso[0].area_formacion==='EDUCACIÓN SUPERIOR UNIVERSITARIA')"
            v-model.trim="stateCourse.formData.fecha"
          >
        </div>
        <div class="col-md-6 p-2">
          <label for="" required>Duración:</label>
          <input 
            type="text"
            class="form-control"
            v-uppercase
            :disabled="stateCourse.formData.id_area_formacion && 
                       (tipoCurso[0].area_formacion==='EDUCACIÓN TÉCNICA ALTERNATIVA' || tipoCurso[0].area_formacion==='EDUCACIÓN SUPERIOR UNIVERSITARIA')"
            v-model.trim="stateCourse.formData.duracion"
          >
        </div>
        <div class="col-md-6 p-2">
          <label for="" required>Carga Horaria:</label>
          <input 
            type="text"
            class="form-control"
            v-uppercase
            :disabled="stateCourse.formData.id_area_formacion && 
                       (tipoCurso[0].area_formacion==='EDUCACIÓN TÉCNICA ALTERNATIVA' || tipoCurso[0].area_formacion==='EDUCACIÓN SUPERIOR UNIVERSITARIA')"
            v-model.trim="stateCourse.formData.carga_horaria"
          >
        </div>
        <p class="p-2" align="right">
            <button
              class="btn btn-danger"
              @click="clearFormCourse()"
            >
              Limpiar
            </button>&nbsp;
            <button
              v-if="!isLoading"
              class="btn btn-success"
              @click="!isEditingCourse?registerCourse():registerEditedCourse()"
              :disabled="!stateCourse.formData.id_area_formacion"
            >
              {{isEditingCourse?'Editar':'Registrar'}} {{capitalize(stateCourse.formData.tipo)}}
            </button>
            <button
                v-else
                class="btn btn-primary"
                disabled
              >
                Por favor espere ...
              </button>
          </p>
      <!-- lista de asignaturas -->
      <div  class="row p-3 table-responsive">
      <h4>Lista de Carreras Univeristarias, Asignaturas, Capacitaciones, Cursos o Talleres</h4>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">N°</th>
              <th scope="col">Acciones</th>
              <th scope="col">Nombre Asignatura</th>
              <th scope="col">Tipo</th>
              <th scope="col">Nombre Área Formación</th>
              <th scope="col">Institución</th>
              <th scope="col">Nivel</th>
              <th scope="col">Fecha</th>
              <th scope="col">Duración</th>
              <th scope="col">Carga Horaria</th>
              <th scope="col">Recinto Penitenciario</th>
              <th scope="col">Departamento</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(asignatura, index) in coursesList" :key="asignatura.id_asignatura">
              <td data-label="N°">{{index+1}}</td>
              <td data-label="Acciones">
              <div v-if="asignatura.dep_recinto!='NACIONAL'" class="icon-container">
               <i class="fa fa-edit fa-2x" style="color:skyblue" title="editar" @click="fillEditCourse(asignatura.id_asignatura)"></i>&nbsp;
              </div>
              <div v-if="asignatura.dep_recinto!='NACIONAL'" class="icon-container">
               <i class="fa fa-trash fa-2x" style="color:red" title="inhabilitar" @click="deleteCourseById(asignatura)"></i>
              </div>
              </td>
              <td data-label="Asignatura">{{asignatura.nombre_asignatura}}</td>
              <td data-label="Tipo">{{asignatura.tipo}}</td>
              <td data-label="Área Formación">{{asignatura.nombre_area_formacion}}</td>
              <td data-label="Institución">{{asignatura.nombre_institucion}}</td>
              <td data-label="Nivel">{{asignatura.nivel}}</td>
              <td data-label="Fecha">{{asignatura.fecha_tabla}}</td>
              <td data-label="Duración">{{asignatura.duracion}}</td>
              <td data-label="Carga Horaria">{{asignatura.carga_horaria}}</td>
              <td data-label="Recinto">{{asignatura.nombre_recinto_penitenciario}}</td>
              <td data-label="Dpto.">{{asignatura.dep_recinto}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>
      <!-- agregar institución -->
      <div v-if="isInstitution" class="row p-3">
      <h4>{{isEditingInstitution?'Edición':'Registro'}} de Institución</h4>
        <div class="col-md-6 p-2">
          <label for="" required>Área de formación:</label>
          <select 
            class="form-select"
            v-model.trim="stateInstitution.formData.id_area_formacion"
            id="area_formacion_institucion"
          >
            <option selected disabled>Seleccione una opción</option>
            <option 
              v-for="area in areasFormacionAgregando" 
              :key="area.id_area_formacion" 
              :value="area.id_area_formacion"
            >
              {{ area.nombre_area_formacion }} - {{area.cod_area_formacion}}
            </option>
          </select>
        </div>
        <div class="col-md-6 p-2">
          <label for="" required>Nombre Institucíon:</label>
          <input 
            type="text"
            class="form-control"
            v-uppercase
            v-model.trim="stateInstitution.formData.institucion"
          >
        </div>
        <div class="col-md-6 p-2">
          <label for="" required>Departamento:</label>
          <select 
            class="form-select"
            v-model.trim="stateInstitution.formData.departamento"
            :disabled="departamento_centro_penitenciario!=='NACIONAL'"
          >
            <option selected disabled>Seleccione una opción</option>
            <option
                v-for="(list, key) in departmentsList"
                :value="list.departamento"
                :key="key"
              >
                {{ list.departamento }}
              </option>
          </select>
        </div>
        
        <p class="p-2" align="right">
            <button
              class="btn btn-danger"
              @click="clearFormInstitution()"
            >
              Limpiar
            </button>&nbsp;
            <button
              v-if="!isLoading"
              class="btn btn-success"
              @click="!isEditingInstitution?registerInstitution():registerEditedInstitution()"
            >
              {{isEditingInstitution?'Editar':'Registrar'}} Institución
            </button>
            <button
                v-else
                class="btn btn-primary"
                disabled
              >
                Por favor espere ...
              </button>
          </p>
      <!-- lista de Instituciones -->
      <div class="row p-3 table-responsive">
      <h4>Lista de Instituciones</h4>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">N°</th>
              <th scope="col">Acciones</th>
              <th scope="col">Nombre Institución</th>
              <th scope="col">Área de Formación</th>
              <th scope="col">Departamento</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(institucion, index) in institutionsList" :key="institucion.id_institucion">
              <td data-label="N°">{{index + 1}}</td>
              <td data-label="Acciones">
                <div v-if="institucion.departamento!=='TODOS'" class="icon-container">
                <i class="fa fa-edit fa-2x" style="color:skyblue" title="editar" @click="fillEditInstitution(institucion.id_institucion)"></i>&nbsp;
                </div>
                <div v-if="institucion.departamento!=='TODOS'" class="icon-container">
                <i class="fa fa-trash fa-2x" style="color:red" title="inhabilitar" @click="deleteInstitutionById(institucion)"></i>
                </div>
              </td>
              <td data-label="NOMBRE">{{institucion.nombre_institucion}}</td>
              <td data-label="ÁREA">{{institucion.nombre_area_formacion}}</td>
              <td data-label="DEPARTAMENTO">{{institucion.departamento}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>
    </div>
  </div>
  <div  v-if="isChart" class="row">
     <div class="card-body col-6">
      <!--begin::Chart-->
      <apexchart
        
        type="area"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
    <div class="card-body col-6">
      <!--begin::Chart-->
      <apexchart type="pie" :options="chartOptionspie" :series="seriespie"></apexchart>
    </div>
     </div>
  <loading
      v-model:active="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      :height="100"
      :width="100"
  ></loading>
  </template>
  <script>
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  inject,
} from "vue";
import Loading from "vue-loading-overlay";
import user from "@/user/composables/useUser";
import useAuth from "@/auth/composables/useAuth";
import filiation from "@/filiation/composables/useFiliation";
import visits from "@/visits/composables/useVisits";
import modEducation from "@/mod_education/composables/useModEducation";
import es from "./../../../../node_modules/apexcharts/dist/locales/es.json"
import Swal from "sweetalert2/dist/sweetalert2.min.js";
export default defineComponent({
  name: "registerEducationForm",
   components: {
        Loading,
        },
  props: {
    nombre_ruta: String,
  },
  setup(props, context){
    const dato_busqueda_ppl =ref();
    const resultados_ppls = ref([]);
    const isLoading = ref(false);
    const departmentsList = ref([]);
    const nameNavbar = computed(() => props.nombre_ruta);
    const isChart = ref(true);
    const isAddingTeacher = ref(false);
    const isListTeachers = ref(false);
    const isAddingStudent = ref(false);
    const isListStudents = ref(false);
    const isListBachelors = ref(false);
    const isCourse = ref(false);
    const isInstitution = ref(false); 
    const isEditingInstitution = ref(false);
    const isEditingStudent = ref(false);
    const isEditingCourse = ref(false);
    const isAddingCoursesTeacher =ref(false);
    const dato_busqueda = ref(null);
    const areaFormacionList =ref([]);
    const institutionsList =ref([]);
    const coursesList = ref([]);
    const prisionsList =ref([]);
    const teachersList =ref([]);
    const studentsList =ref([]);


    const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
    });
    let chartOptions = ref({
      chart: {
        id: "vuechart",
        locales: [es],
        defaultLocale: "es",
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: false,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: false,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: [],
          },
          export: {
            csv: {
              filename: "Sirep_report",
              columnDelimiter: ":",
              headerCategory: "category",
              headerValue: "value",
              dateFormatter(timestamp) {
                return new Date(timestamp).toDateString();
              },
            },
            svg: {
              filename: "Sirep_report",
            },
            png: {
              filename: "Sirep_report",
            },
          },
          autoSelected: "zoom",
        },
      },
      xaxis: {
        categories: [],
        labels: {
          show: true,
          rotate: -800,
          rotateAlways: true,
          hideOverlappingLabels: false,
          showDuplicates: false,
          trim: true,
          minHeight: 200,
          maxHeight: 200,
          style: {
            colors: [],
            fontSize: "12px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 200,
            cssClass: "apexcharts-xaxis-label",
          },
          offsetX: 0,
          offsetY: 0,
        },
      },
    });
    let series = ref([
      {
        name: "Personas privadas de libertad",
        data: [],
      },
    ]);
    let seriespie= ref([44, 55, 13, 43, 22]);
    const chartOptionspie= ref({
            chart: {
              width: 380,
              type: 'pie',
            }});
    
    const {
      // searchSegip,
      nameDepartments,
      // nameProvinces,
      // namePenitentiaries,
      // nameRoles,
      // createUser,
      // infoUser,
      // infoRolesUser,
      // infoPasswordUser,
      // updateUser,
      // sendMail,
    } = user();
    const {
      // rol,
      // nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      // departamento_supervisar,
       id_recinto,
    } = useAuth();
    const { valueToSearch } = visits();
    const {prisionNames} = filiation();
    const {
           getAreaFormacion, 
           saveInstitution, 
           getInstitutions, 
           editInstitution, 
           deleteInstitution,

           saveCourse,
           getCourses,
           editCourse,
           deleteCourse,

           saveTeacher,
           getTeachers,
           deleteTeacherById,
           deleteTeacherCourseById,

           saveStudent,
           getStudents,
           editStudent,
           deleteStudentById
           
           } = modEducation();
    const searchPpl = async (value) => {
        isLoading.value = true;
        const { data } = await valueToSearch(value.toUpperCase());
        if (!data.ok) {
          Toast.fire({
            icon: "info",
            title: "No existen coincidencias con los datos ingresados",
          });
          isLoading.value = false;
        } else {
            Toast.fire({
              icon: "success",
              title: "La búsqueda retornó resultados!",
            });
          isLoading.value = false;
          resultados_ppls.value = data.respuesta;
        }
      };
// verificar si campos de busqueda estan vacios
    const checkFieldEmpty = (dato, type) => {
      if (dato === "" && type === "dato_ppl") {
        stateStudent.formData.id_persona = null;
        resultados_ppls.value = [];
      }
    };      
    const listPrisions = async () => {
      const { data } = await prisionNames();
      if (departamento_centro_penitenciario.value!=='NACIONAL') {
         const result = data.filter( value => value.id_recinto_penitenciario===id_recinto.value)
         prisionsList.value = result;        
      } else {
        prisionsList.value = data;
      }
    };
    const listNameDepartments = async () => {
      const { data } = await nameDepartments();
      departmentsList.value = data;
    };
    const capitalize = (word) => {
      if (!word) return ''; // Manejar el caso de una cadena vacía
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    };
    const getAreaFormacionList = async () =>{
      const { data } = await getAreaFormacion();
        areaFormacionList.value = data;
    };
    const getInstitutionList = async () =>{
      const { data } = await getInstitutions(departamento_centro_penitenciario.value);
      if (stateCourse.formData.id_area_formacion) {
        institutionsList.value = data.filter(value =>{value.cod_area_formacion==stateCourse.formData.id_area_formacion})
      } else {
        institutionsList.value = data;
      }

    }
    const getCoursesList = async () =>{
      const { data } = await getCourses(id_recinto.value);
      if (stateCourse.formData.id_recinto_penitenciario) {
      coursesList.value = data.filter(value =>{value.cod_recinto_penitenciario==id_recinto.value})
      }
      coursesList.value = data;
    }
    const getNameFromCourse = (materia, name) =>{
      if (name==='nombre_institucion') {
        const res = coursesList.value.find(value => value.id_asignatura ===materia.id_asignatura)
        return res.nombre_institucion
      }else if (name==='nombre_area_formacion') {
        const res = areaFormacionList.value.find(value => value.id_area_formacion ===materia.id_area_formacion)
        return res.nombre_area_formacion
      }else if (name==='nombre_asignatura') {
        const res = coursesList.value.find(value => value.id_asignatura ===materia.id_asignatura)
        return res.nombre_asignatura
      }
    }
    const fillEditCourse = (id) =>{
      isEditingCourse.value = true;
      const selectElement = document.getElementById('recinto_penitenciario');
      if (selectElement) {
        selectElement.focus(); 
      }
      const result = coursesList.value.filter((value)=> value.id_asignatura === id)
        stateCourse.formData.id_asignatura=result[0].id_asignatura,
        stateCourse.formData.id_recinto_penitenciario=result[0].cod_recinto_penitenciario,
        stateCourse.formData.id_area_formacion=result[0].cod_area_formacion,
        stateCourse.formData.tipo=result[0].tipo,
        stateCourse.formData.nivel=result[0].nivel,
        stateCourse.formData.nombre=result[0].nombre_asignatura,
        stateCourse.formData.institucion=result[0].cod_institucion,
        stateCourse.formData.fecha=result[0].fecha,
        stateCourse.formData.duracion=result[0].duracion,
        stateCourse.formData.carga_horaria=result[0].carga_horaria
    }
    const fillEditInstitution = (id) =>{
      isEditingInstitution.value = true;
      const selectElement = document.getElementById('area_formacion_institucion');
      if (selectElement) {
        selectElement.focus();; 
      }
      const result = institutionsList.value.filter((value)=> value.id_institucion === id)
        stateInstitution.formData.id_institucion=result[0].id_institucion,
        stateInstitution.formData.id_area_formacion=result[0].cod_area_formacion,
        stateInstitution.formData.institucion=result[0].nombre_institucion,
        stateInstitution.formData.departamento=result[0].departamento
    }
    const deleteInstitutionById = async (institucion) =>{
      Swal.fire({
        title: `¿Está seguro de eliminar a ${institucion.nombre_institucion} del departamento de ${institucion.departamento}?`,
        text: "Esta acción no podrá ser revertida",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "¡Si, eliminar!",
        cancelButtonText: "¡No, retornar!",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
              isLoading.value=true;
              const { data } = await deleteInstitution(institucion.id_institucion);
              if (data.ok) {
                  Swal.fire({
                    title: "¡Realizado!",
                    text: `La institución ${institucion.nombre_institucion} de ${institucion.departamento} fue eliminada satisfactoriamente`,
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });
                  getInstitutionList()
                  // router.push({name:"listDeprivedLibertybyPrisons"})
              }
          } catch (error) {   
            console.log(error);
            Swal.fire({
                    title: "¡Error!",
                    text: `La institución no pudo ser eliminada`,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });       
          }finally{
            isLoading.value=false
          }
        }
      });
    }
    const deleteCourseById = async (asignatura) =>{
      Swal.fire({
        title: `¿Está seguro de eliminar ${asignatura.nombre_asignatura} de ${asignatura.nombre_institucion} del Recinto Penitenciario ${asignatura.nombre_recinto_penitenciario}?`,
        text: "Esta acción no podrá ser revertida",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "¡Si, eliminar!",
        cancelButtonText: "¡No, retornar!",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
              isLoading.value=true;
              const { data } = await deleteCourse(asignatura.id_asignatura);
              if (data.ok) {
                  Swal.fire({
                    title: "¡Realizado!",
                    text: `Eliminación realizada satisfactoriamente`,
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });
                  await getCoursesList()
                  // router.push({name:"listDeprivedLibertybyPrisons"})
              }
          } catch (error) {   
            console.log(error);
            Swal.fire({
                    title: "¡Error!",
                    text: `La eliminación no pudo ser realizada`,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });       
          }finally{
            isLoading.value=false
          }
        }
      });
    }
    const areasFormacionAgregando = computed(()=>{
      let filtrado;
       if (isCourse.value || isInstitution.value) {
        filtrado = areaFormacionList.value.filter(area =>
          area.nombre_area_formacion === "EDUCACIÓN NO FORMAL" || 
          area.nombre_area_formacion === "EDUCACIÓN TÉCNICA ALTERNATIVA" || 
          area.nombre_area_formacion === "EDUCACIÓN SUPERIOR UNIVERSITARIA"
         )
       }
      //else if(isInstitution.value){
      //     filtrado = areaFormacionList.value.filter(area =>
      //     area.nombre_area_formacion === "EDUCACIÓN NO FORMAL" || 
      //     area.nombre_area_formacion === "EDUCACIÓN SUPERIOR UNIVERSITARIA"
      //    )     
      //   }
        return filtrado
    })
    const tipoCurso = computed(()=>{
      const tipos = [
         {area_formacion:'EDUCACIÓN TÉCNICA ALTERNATIVA', valor:'ASIGNATURA', label:'ASIGNATURA'},
         {area_formacion:'EDUCACIÓN NO FORMAL', valor:'CAPACITACIÓN', label:'CAPACITACIÓN'},
         {area_formacion:'EDUCACIÓN NO FORMAL', valor:'CURSO', label:'CURSO'},
         {area_formacion:'EDUCACIÓN NO FORMAL', valor:'TALLER', label:'TALLER'},
         {area_formacion:'EDUCACIÓN SUPERIOR UNIVERSITARIA', valor:'CARRERA UNIVERSITARIA', label:'CARRERA UNIVERSITARIA'}
      ]
      if (stateCourse.formData.id_area_formacion) {
              const result = areaFormacionList.value.filter(value =>value.id_area_formacion === stateCourse.formData.id_area_formacion)
        const tipo_result =tipos.filter(value => value.area_formacion===result[0].nombre_area_formacion)
        return tipo_result
      }
    })
    const institutionsListByAreaFormacion = computed(()=>{
      if (stateCourse.formData.id_area_formacion) {
              const result = institutionsList.value.filter(value =>value.cod_area_formacion == stateCourse.formData.id_area_formacion)
        return result
      }
    })
    const asignaturaListByAreaFormacion = computed(()=>{
      if (teacherClass.id_area_formacion) {
              const result = coursesList.value.filter(value =>value.cod_area_formacion == teacherClass.id_area_formacion)
        return result
      }else if(stateStudent.formData.id_area_formacion){
         const result = coursesList.value.filter(value =>value.cod_area_formacion == stateStudent.formData.id_area_formacion)
        return result
      }
    })
    const teacher = reactive({
        nombre_completo:"",
        numero_documento:"",
    });
    const teacherClass = reactive ({
        id_area_formacion:"",
        id_asignatura:"",
        hora_ingreso:"",
        hora_salida:""
    })
    const stateTeacher = reactive([{
        id_profesor:0,
        nombre_completo:"",
        numero_documento:"",
        materias:[]
    }
    ]);
    const stateStudent = reactive({
      formData: {
        id_estudiante_asignatura:0,
        id_persona:"",
        id_asignatura:"",
        id_area_formacion:"",
      },
    });
    const stateCourse = reactive({
      formData: {
        id_asignatura:"",
        id_recinto_penitenciario:"",
        id_area_formacion:"",
        tipo:"",
        nivel:"",
        nombre:"",
        institucion:"",
        fecha:"",
        duracion:"",
        carga_horaria:""
      },
    });
    const stateInstitution = reactive({
      formData: {
        id_institucion:"",
        institucion:"",
        id_area_formacion:"",
        departamento:""
      },
    });
    const addTeacherToArray = () => {
      stateTeacher[0].materias.push({ ...teacherClass });
       clearFormTeacher();
    };
    const deleteTeacher = (index) => {
      stateTeacher[0].materias.splice(index, 1);
     };
    const editTeacher = (value, index) => {
      for (let i in stateTeacher[0].materias) {
        if (i == index) {
          teacherClass.id_asignatura = stateTeacher[0].materias[i].id_asignatura;
          teacherClass.id_area_formacion = stateTeacher[0].materias[i].id_area_formacion;
          teacherClass.hora_ingreso = stateTeacher[0].materias[i].hora_ingreso;
          teacherClass.hora_salida = stateTeacher[0].materias[i].hora_salida;
          break;
        }
      }
      deleteTeacher(index);
    };
    const addTeacher = () =>{
      isAddingTeacher.value = !isAddingTeacher.value;
      isListTeachers.value = false;
      isListBachelors.value = false;
      closeAllStudent();
      closeAllCourse();
      closeAllInstitution();
      getCoursesList();
      if(isChart.value == true){
        isChart.value = false 
      }
      if (!isAddingTeacher.value) {
        isChart.value = true;
      }      
    }
    const clearFormTeacher = () => {
        teacherClass.id_asignatura="",
        teacherClass.id_area_formacion="",
        teacherClass.hora_ingreso="",
        teacherClass.hora_salida=""
    }
    const listTeachers = () => {
      isListTeachers.value = !isListTeachers.value
      isAddingTeacher.value = false;
      isListBachelors.value = false;
      closeAllStudent();
      closeAllCourse();
      closeAllInstitution();
      getTeachersList();
      if(isChart.value == true){
        isChart.value = false 
      }
      if (!isListTeachers.value) {
        isChart.value = true
      }
    }
    const closeAllTeachers = () =>{
      isListTeachers.value = false;
      isAddingTeacher.value = false;
      teacher.nombre_completo="",
      teacher.numero_documento="",
      stateTeacher[0].id_profesor=0,
      stateTeacher[0].nombre_completo="",
      stateTeacher[0].numero_documento="",
      stateTeacher[0].materias=[],
      clearFormTeacher()
    }
    const validateRegisterTeacherForm = () =>{
      if(!stateTeacher[0].nombre_completo || !stateTeacher[0].numero_documento || stateTeacher[0].materias.length==0){
        return {ok:false,message:"El nombre y el número de documento y al menos una asignatura o especialidad son requeridos" }
      }else{
      return{ok:true}
      }
    }
    const registerTeacher = async() => {
    const {ok, message} = validateRegisterTeacherForm()
      if(!ok){
        alert(`${message}`)
      }else{
        try {
            isLoading.value=true;
            const { data } = await saveTeacher(stateTeacher[0]);
            if (data.ok) {
                Swal.fire({
                  title: "¡Realizado!",
                  text: `El profesor fue añadido exitosamente`,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });
                stateTeacher[0].nombre_completo='';
                stateTeacher[0].numero_documento='';
                stateTeacher[0].materias=[];
            }
        } catch (error) {   
          console.log(error);
          Swal.fire({
                  title: "¡Error!",
                  text: `El registro no pudo ser realizado`,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });       
        }finally{
          isLoading.value=false;
          isAddingCoursesTeacher.value=false;
        }
      }
    }
    const getTeachersList = async () =>{
      const { data } = await getTeachers(id_recinto.value);
      // if (stateCourse.formData.id_recinto_penitenciario) {
      // teachersList.value = data.filter(value =>{value.cod_recinto_penitenciario==id_recinto.value})
      // }
      teachersList.value = data;
    }
    const addCoursesTeacher = async(profesor)=>{
      isAddingTeacher.value=true;
      isListTeachers.value=false;
      isAddingCoursesTeacher.value=true;
      await getCoursesList()
      stateTeacher[0].id_profesor=profesor.id_profesor;
      stateTeacher[0].nombre_completo=profesor.nombre_completo;
      stateTeacher[0].numero_documento=profesor.numero_documento;
    }
    const deleteTeacherRegistered = async (profesor) =>{
      Swal.fire({
        title: `¿Está seguro de eliminar a ${profesor.nombre_completo} y todas sus asignaturas?`,
        text: "Esta acción no podrá ser revertida",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "¡Si, eliminar!",
        cancelButtonText: "¡No, retornar!",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
              isLoading.value=true;
              const { data } = await deleteTeacherById(profesor.id_profesor);
              if (data.ok) {
                  Swal.fire({
                    title: "¡Realizado!",
                    text: `La eliminación fue realizada con éxito`,
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });
                  getTeachersList()
                  // router.push({name:"listDeprivedLibertybyPrisons"})
              }
          } catch (error) {   
            console.log(error);
            Swal.fire({
                    title: "¡Error!",
                    text: `La institución no pudo ser eliminada`,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });       
          }finally{
            isLoading.value=false
          }
        }
      });
    }
    const deleteTeacherCourseRegistered = async (asignatura, profesor) =>{
      Swal.fire({
        title: `¿Está seguro de eliminar la asignatura ${asignatura.nombre_asignatura} del profesor ${profesor.nombre_completo}?`,
        text: "Esta acción no podrá ser revertida",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "¡Si, eliminar!",
        cancelButtonText: "¡No, retornar!",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
              isLoading.value=true;
              const { data } = await deleteTeacherCourseById(asignatura.id_profesor_asignatura, asignatura.cod_profesor);
              if (data.ok) {
                  Swal.fire({
                    title: "¡Realizado!",
                    text: `La eliminación fue realizada con éxito`,
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });
                  getTeachersList()
                  // router.push({name:"listDeprivedLibertybyPrisons"})
              }
          } catch (error) {   
            console.log(error);
            Swal.fire({
                    title: "¡Error!",
                    text: `La institución no pudo ser eliminada`,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });       
          }finally{
            isLoading.value=false
          }
        }
      });
    }


    const addStudent = () =>{
      isAddingStudent.value = !isAddingStudent.value
      isListStudents.value = false;
      isListBachelors.value = false;
      closeAllTeachers();
      closeAllCourse();
      closeAllInstitution();
      getCoursesList();
      if(isChart.value == true){
        isChart.value = false 
      }
      if (!isAddingStudent.value) {
        isChart.value = true
      }
    }
    const clearFormStudent = () => {
        stateStudent.formData.id_persona="",
        stateStudent.formData.id_asignatura="",
        stateStudent.formData.id_area_formacion=""
        isAddingStudent.value=false
    }
    const listStudents = () => {
      isListStudents.value = !isListStudents.value
      isAddingStudent.value = false;
      isListBachelors.value = false;
      closeAllTeachers();
      closeAllCourse();
      closeAllInstitution();
      getStudentsList()
      if(isChart.value == true){
        isChart.value = false 
      }
      if (!isListStudents.value) {
        isChart.value = true
      }
    }
    const closeAllStudent = () =>{
      isListStudents.value = false;
      isAddingStudent.value = false;
      clearFormStudent()
    }
    const listBachelors = () => {
      closeAllStudent();
      closeAllTeachers();
      closeAllCourse();
      closeAllInstitution();
      isListBachelors.value = !isListBachelors.value;
      if(isChart.value == true){
        isChart.value = false 
      }
      if (!isListBachelors.value) {
        isChart.value = true
      }
    }
    const validateRegisterStudentForm = computed(()=>{
      if ( !stateStudent.formData.id_persona || !stateStudent.formData.id_asignatura || !stateStudent.formData.id_area_formacion) {
        return false
      }else{
        return true
      }
    })
    const registerStudent = async() =>{
      if (!validateRegisterStudentForm) {
        alert("Todos los campos deben estar completos para el registro")
      }else{
        try {
            isLoading.value=true;
            const { data } = await saveStudent(stateStudent.formData);
            if (data.ok) {
                Swal.fire({
                  title: "¡Realizado!",
                  text: `El registro fue realizado correctamente`,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });
                // await getInstitutionList()
            }
        } catch (error) {   
          console.log(error);
          Swal.fire({
                  title: "¡Error!",
                  text: `El registro no pudo ser realizado`,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });       
        }finally{
          isLoading.value=false
        }
      }  console.log("stateStudent.formData", stateStudent.formData);
    }
    const getStudentsList = async () =>{
      const { data } = await getStudents(id_recinto.value);
      // if (stateCourse.formData.id_recinto_penitenciario) {
      // teachersList.value = data.filter(value =>{value.cod_recinto_penitenciario==id_recinto.value})
      // }
      studentsList.value = data;
    }
    const fillEditStudent= async(id) =>{
      isAddingStudent.value=true;
      isListStudents.value=false;
      isEditingStudent.value = true;
      const selectElement = document.getElementById('dato');
      if (selectElement) {
        selectElement.focus();
      }
      const result = studentsList.value.filter((value)=> value.cod_persona === id.cod_persona)
        stateStudent.formData.id_estudiante_asignatura=result[0].id_estudiante_asignatura,
        stateStudent.formData.id_persona=result[0].cod_persona,
        stateStudent.formData.id_area_formacion=result[0].cod_area_formacion,
        stateStudent.formData.id_asignatura=result[0].cod_asignatura;
        getCoursesList()
        await searchPpl(result[0].nombre_completo)
    }
    const registerEditedStudent = async() =>{
      if (!validateRegisterStudentForm) {
        alert("Todos los campos deben estar completos para el registro")
      }else{
        try {
            isLoading.value=true;
            const { data } = await editStudent(stateStudent.formData);
            if (data.ok) {
                Swal.fire({
                  title: "¡Realizado!",
                  text: `El estudiante fue editado correctamente`,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });
                clearFormStudent()
                isListStudents.value=true;
                await getStudentsList()
                
            }
        } catch (error) {   
          console.log(error);
          Swal.fire({
                  title: "¡Error!",
                  text: `El estudiante no fue editado correctamente`,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });       
        }finally{
          isLoading.value=false
        }
      }
    }
    const deleteStudent = async (student) =>{
        Swal.fire({
          title: `¿Está seguro de eliminar a ${student.nombre_completo}?`,
          text: "Esta acción no podrá ser revertida",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "¡Si, eliminar!",
          cancelButtonText: "¡No, retornar!",
          reverseButtons: true
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
                isLoading.value=true;
                const { data } = await deleteStudentById(student.id_estudiante_asignatura);
                if (data.ok) {
                    Swal.fire({
                      title: "¡Realizado!",
                      text: `La eliminación fue realizada con éxito`,
                      icon: "success",
                      buttonsStyling: false,
                      confirmButtonText: "Continuar",
                      customClass: {
                        confirmButton: "btn fw-bold btn-light-primary",
                      },
                    });
                    getStudentsList()
                }
            } catch (error) {   
              console.log(error);
              Swal.fire({
                      title: "¡Error!",
                      text: `La institución no pudo ser eliminada`,
                      icon: "error",
                      buttonsStyling: false,
                      confirmButtonText: "Continuar",
                      customClass: {
                        confirmButton: "btn fw-bold btn-light-primary",
                      },
                    });       
            }finally{
              isLoading.value=false
            }
          }
        });
    }


    const addCourse = () => {
      closeAllStudent();
      closeAllTeachers();
      closeAllInstitution();
      getInstitutionList();
      getCoursesList();
      isListBachelors.value = false;
      isCourse.value = !isCourse.value;
      if(isChart.value == true){
        isChart.value = false 
      }
      if (!isCourse.value) {
        isChart.value = true
      }
    } 
    const closeAllCourse = () => {
      isCourse.value = false;
      clearFormCourse();
    }
    const clearFormCourse = () => {
        stateCourse.formData.id_asignatura="",
        stateCourse.formData.id_recinto_penitenciario="",
        stateCourse.formData.id_area_formacion="",
        stateCourse.formData.nombre="",
        stateCourse.formData.tipo="",
        stateCourse.formData.nivel="",
        stateCourse.formData.institucion="",
        stateCourse.formData.fecha="",
        stateCourse.formData.duracion="",
        stateCourse.formData.carga_horaria="",
        isEditingCourse.value = false
    };
    const validateRegisterCourseForm = () =>{
      const area_formacion = areaFormacionList.value.filter(value => value.id_area_formacion==stateCourse.formData.id_area_formacion)
      if (area_formacion[0].nombre_area_formacion=='EDUCACIÓN TÉCNICA ALTERNATIVA' &&
          ( !stateCourse.formData.id_recinto_penitenciario ||
            !stateCourse.formData.id_area_formacion ||
           !stateCourse.formData.tipo ||
           !stateCourse.formData.nombre ||
           !stateCourse.formData.nivel ||
           !stateCourse.formData.institucion
          )
      ) {
        return false
      } else if (area_formacion[0].nombre_area_formacion=='EDUCACIÓN NO FORMAL' &&
          (
            !stateCourse.formData.id_area_formacion ||
           !stateCourse.formData.tipo ||
           !stateCourse.formData.nombre ||
           !stateCourse.formData.institucion ||
           !stateCourse.formData.fecha ||
           !stateCourse.formData.duracion ||
           !stateCourse.formData.carga_horaria
          ))
       {
        return false
      }else{
        return true
      }
    }
    const registerCourse = async() => {
      if(!validateRegisterCourseForm()){
        alert("todos los campos habilitados son requeridos")
      }else{
        let message;
        if (stateCourse.formData.tipo=='ASIGNATURA' || stateCourse.formData.tipo=='CAPACITACIÓN') {
          message =`¡La ${stateCourse.formData.tipo} fue añadida exitosamente!`
        } else {
          message =`¡${stateCourse.formData.tipo} fue añadido exitosamente!`
        }
        try {
            isLoading.value=true;
            const { data } = await saveCourse(stateCourse.formData);
            if (data.ok) {
                Swal.fire({
                  title: "¡Realizado!",
                  text: `${message}`,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });
                clearFormCourse()
                 await getCoursesList()
            }
        } catch (error) {   
          console.log(error);
          Swal.fire({
                  title: "¡Error!",
                  text: `El registro no pudo ser realizado`,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });       
        }finally{
          isLoading.value=false
        }
      }
    }
    const registerEditedCourse = async() =>{
      if(!validateRegisterCourseForm()){
        alert("todos los campos habilitados son requeridos")
      }else{
        try {
            isLoading.value=true;
            const { data } = await editCourse(stateCourse.formData);
            if (data.ok) {
                Swal.fire({
                  title: "¡Realizado!",
                  text: `La edición fue realizada correctamente`,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });
                clearFormCourse()
                await getCoursesList()
            }
        } catch (error) {   
          console.log(error);
          Swal.fire({
                  title: "¡Error!",
                  text: `La edición no pudo ser realizada`,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });       
        }finally{
          isLoading.value=false
        }
      }
    };
    const clearInputsAreaFormation =(id)=>{
      const res=areaFormacionList.value.filter(value => value.id_area_formacion === id)
      if(res[0].nombre_area_formacion!='EDUCACIÓN TÉCNICA ALTERNATIVA'){
        stateCourse.formData.nivel='';
      }else if(res[0].nombre_area_formacion!='EDUCACIÓN NO FORMAL'){
        stateCourse.formData.fecha='';
        stateCourse.formData.duracion='';
        stateCourse.formData.carga_horaria='';
      }else if(res[0].nombre_area_formacion=='EDUCACIÓN SUPERIOR UNIVERSITARIA'){
        stateCourse.formData.nivel='';
        stateCourse.formData.fecha='';
        stateCourse.formData.duracion='';
        stateCourse.formData.carga_horaria='';
      }
    };
    const addInstitution = () =>{
      closeAllStudent();
      closeAllTeachers();
      closeAllCourse();
      getInstitutionList();
      isInstitution.value = !isInstitution.value;
      if(isChart.value == true){
        isChart.value = false 
      }
      if (!isInstitution.value) {
        isChart.value = true
      }
    };
    const closeAllInstitution = () => {
      isInstitution.value = false;
      clearFormInstitution();
    }
    const clearFormInstitution = () => {
        stateInstitution.formData.id_institucion="",
        stateInstitution.formData.id_area_formacion="",
        stateInstitution.formData.institucion="",
        stateInstitution.formData.departamento="",
        isEditingInstitution.value = false
    };
    const registerInstitution = async() =>{
      if (stateInstitution.formData.id_area_formacion =='' || stateInstitution.formData.institucion=='' || stateInstitution.formData.departamento=='') {
        alert("Todos los campos deben estar completos para el registro")
      }else{
        try {
            isLoading.value=true;
            const { data } = await saveInstitution(stateInstitution.formData);
            if (data.ok) {
                Swal.fire({
                  title: "¡Realizado!",
                  text: `La institución fue registrada correctamente`,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });
                await getInstitutionList()
                // router.push({name:"listDeprivedLibertybyPrisons"})
            }
        } catch (error) {   
          console.log(error);
          Swal.fire({
                  title: "¡Error!",
                  text: `La institución no fue registrada correctamente`,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });       
        }finally{
          isLoading.value=false
        }
      }      
    }
    const registerEditedInstitution = async() =>{
      if (stateInstitution.formData.id_area_formacion =='' || stateInstitution.formData.institucion=='' || stateInstitution.formData.departamento=='') {
        alert("no se puede proceder con la edición")
      }else{
        try {
            isLoading.value=true;
            const { data } = await editInstitution(stateInstitution.formData);
            if (data.ok) {
                Swal.fire({
                  title: "¡Realizado!",
                  text: `La institución fue editada correctamente`,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });
                clearFormInstitution()
                await getInstitutionList()
            }
        } catch (error) {   
          console.log(error);
          Swal.fire({
                  title: "¡Error!",
                  text: `La institución no fue editada correctamente`,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });       
        }finally{
          isLoading.value=false
        }
      }
    }  
    
    onMounted(() => {
        listNameDepartments();
        getAreaFormacionList();
        listPrisions();
        if(departamento_centro_penitenciario.value!=='NACIONAL'){
          stateInstitution.formData.departamento=departamento_centro_penitenciario.value
        }
        // setCurrentPageBreadcrumbs(`${title.value} de Restricción de Visitante`, ["Visitas"]);
      });
    return{
      dato_busqueda_ppl,
      searchPpl,
      checkFieldEmpty,
      resultados_ppls,

      isLoading,
      capitalize,
      departmentsList,
      prisionsList,
      teachersList,
      isAddingCoursesTeacher,
      

      areaFormacionList,
      areasFormacionAgregando, 
      departamento_centro_penitenciario,
      id_recinto,
      institutionsList,
      fillEditInstitution,
      deleteInstitutionById,

      tipoCurso,
      institutionsListByAreaFormacion,
      coursesList,
      getNameFromCourse,
      deleteCourseById,
      

      nameNavbar,
      isAddingTeacher,
      stateTeacher,
      teacher,
      teacherClass,
      addTeacher,
      clearFormTeacher,
      listTeachers,
      isListTeachers,
      closeAllTeachers,
      addTeacherToArray,
      editTeacher,
      deleteTeacher,
      registerTeacher,
      addCoursesTeacher,
      deleteTeacherRegistered,
      deleteTeacherCourseRegistered,

      asignaturaListByAreaFormacion,

      isAddingStudent,
      stateStudent,
      addStudent,
      clearFormStudent,
      listStudents,
      isListStudents,
      closeAllStudent,
      registerStudent,
      validateRegisterStudentForm,
      studentsList,
      fillEditStudent,
      registerEditedStudent,
      deleteStudent,



      dato_busqueda,

      listBachelors,
      isListBachelors,
      isEditingStudent,

      isCourse,
      isEditingCourse,
      registerCourse,
      fillEditCourse,
      registerEditedCourse,

      isInstitution,
      isEditingInstitution,
      addCourse, 
      addInstitution,
      stateCourse,
      clearFormCourse,
      
      clearFormInstitution,
      registerInstitution,
      registerEditedInstitution,



      stateInstitution,

      isChart,   
      chartOptions, 
      series,
      chartOptionspie,
      seriespie,

      clearInputsAreaFormation

    }
  },
  directives: {
    // transform input to uppercase with v-uppercase
    uppercase: {
      updated: function (el) {
        el.value = el.value.toUpperCase();
        el.dispatchEvent(new Event("input"));
      },
    },
  }
})
</script>
<style scoped>
table   {
  width: 100%;
  border-collapse: collapse;
}

.table td,
.table th {
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: center;
  font-size: 13px;
}
.table th {
  background-color: #92c9e6;
  color: #ffffff;
}

.table tbody tr:nth-child(even) {
  background-color: #d1e8f5;
}
.icon-container {
  display: inline-block;
  padding-right: 5px;
  cursor: pointer;
}
.icon-container i {
  font-size: 24px; /* Tamaño original del icono */
  transition: transform 0.3s ease; /* Transición suave */
}

.icon-container i:hover {
  transform: scale(1.2); /* Aumentar el tamaño del icono al hacer hover */
}
@media (max-width: 500px) {
  .table thead {
    display: none;
  }

  .table,
  .table tbody,
  .table tr,
  .table td {
    display: block;
    width: 100%;
  }
  .table tr {
    margin-bottom: 15px;
  }
  .table td {
    padding-left: 50%;
    text-align: left;
    position: relative;
  }
  .table td::before {
    content: attr(data-label);
    position: absolute;
    left: 0;
    width: 50%;
    padding-left: 15px;
    font-size: 15px;
    font-weight: bold;
    text-align: left;
  }
}
.cursor_pointer {
  cursor: pointer;
}
</style>